import { Box, styled } from '@mui/material';
import { useMaterialUIController } from 'context';

const StyledTextArea = styled('textarea')(({ theme, darkMode }) => ({
    width: '80%',
    padding: theme.spacing(1),
    fontSize: '16px',
    lineHeight: 1.5,
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: theme.shape.borderRadius,
    resize: 'vertical',
    transition: 'border-color 0.3s ease',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    color: '#495057',
    color: darkMode ? '#ffffff' : '#495057',
    backgroundColor: darkMode ? 'transparent' : '#fff',
    '&:focus': {
        borderColor: darkMode ? '#fff' : '#000',
        outline: 'none',
    },
}));

const TextAreaContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '16px',
});



const MDTextArea = ({ rows = 4, placeholder, value, onChange }) => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
        <TextAreaContainer>
            <StyledTextArea
                rows={rows}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                darkMode={darkMode}
            />
        </TextAreaContainer>
    );
};

export default MDTextArea;
